const NICKNAME_KEY = 'sprinters.nickname';
const SESSION_KEY = 'sprinters.session';

export interface StoredSession {
  code: string;
  sessionToken: string;
}

function safeGet(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(storage: Storage, key: string, value: string | null): void {
  try {
    if (value === null) storage.removeItem(key);
    else storage.setItem(key, value);
  } catch {
    // Stockage indisponible (navigation privée...) : on continue sans persistance.
  }
}

/** Le pseudo est partagé entre onglets. */
export function loadNickname(): string {
  return safeGet(localStorage, NICKNAME_KEY) ?? '';
}

export function saveNickname(nickname: string): void {
  safeSet(localStorage, NICKNAME_KEY, nickname);
}

/** La session est propre à l'onglet, pour pouvoir tester plusieurs joueurs dans un même navigateur. */
export function loadSession(): StoredSession | null {
  const raw = safeGet(sessionStorage, SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredSession>;
    if (typeof parsed.code === 'string' && typeof parsed.sessionToken === 'string') {
      return { code: parsed.code, sessionToken: parsed.sessionToken };
    }
  } catch {
    // Contenu corrompu : ignoré.
  }
  return null;
}

export function saveSession(session: StoredSession | null): void {
  safeSet(sessionStorage, SESSION_KEY, session ? JSON.stringify(session) : null);
}
